export const DEFAULT_LOCALE = 'en'
export const ENGLISH_US_LOCALE = 'en-US'
